import React, { useRef, useState } from "react";
import {
    Box, Image, Icon, Text, CloseButton, useColorModeValue, Flex
} from "@chakra-ui/react";
import { FiCamera } from "react-icons/fi";
import {useTranslation} from "react-i18next";

/** props.onFile(file) ─> parent */
export default function MobilePhotoPicker({ onFile }) {
    const [preview, setPreview] = useState(null);
    const inputRef = useRef(null);
    const border = useColorModeValue("gray.300", "gray.600");
    const { t } = useTranslation();

    const pickFile = files => {
        const file = files?.[0];
        if (!file) return;
        onFile(file);
        setPreview(URL.createObjectURL(file));
    };

    return (
        <>
            {/* hidden input – launches CAMERA on mobile */}
            <input
                ref={inputRef}
                type="file"
                accept="image/*"
                style={{display: "none"}}
                onChange={e => pickFile(e.target.files)}
            />

            <Box
                role="button"
                w="100%"
                minH="140px"
                border="2px dashed"
                borderColor={border}
                borderRadius="lg"
                display="flex"
                alignItems="center"
                justifyContent="center"
                cursor="pointer"
                _hover={{ borderColor: "teal.400" }}
                onClick={() => inputRef.current?.click()}
            >
                {/* show preview or camera prompt */}
                {preview ? (
                    <Flex position="relative">
                        <Image
                            src={preview}
                            alt="meal preview"
                            borderRadius="md"
                            objectFit="cover"
                            maxH="180px"
                        />
                        <CloseButton
                            size="sm"
                            position="absolute"
                            top="4px"
                            right="4px"
                            bg="blackAlpha.600"
                            color="white"
                            _hover={{ bg: "blackAlpha.800" }}
                            onClick={e => {
                                e.stopPropagation();
                                setPreview(null);
                                onFile(null);
                            }}
                        />
                    </Flex>
                ) : (
                    <Flex direction="column" align="center" color="gray.500">
                        <Icon as={FiCamera} boxSize={8} mb={2} />
                        <Text fontSize="sm">{t("photoPicker.tapToSnap")}</Text>
                    </Flex>
                )}
            </Box>
        </>
    );
}